export enum InstructionRsjTraceabilityStatus {
  Creation = 'En création',
  Accepted = 'Acceptée',
  Refused = 'Refusée',
  Analysis = 'Analyse en cours',
  WaitingForInfo = "Demande d'informations",
  PaymentInProgress = 'Versement en cours',
  Done = 'Terminée',
  PaymentError = 'Erreur de paiement',
  SuspensionInProgress = 'Suspension en instruction',
  Suspended = 'Suspendue',
  WaitingForNonRenewal = 'Motif de non renouvel. à renseigner',
}
